import { dia } from '@joint/plus';

type JointElement = dia.Element;

export function alignLeft(cells: JointElement[]): void {
  const minX = Math.min(...cells.map(cell => cell.position().x));
  cells.forEach(cell => {
    const { y } = cell.position();
    cell.position(minX, y);
  });
}

export function alignCenter(cells: JointElement[]): void {
  const centerX = cells.reduce((sum, cell) => sum + cell.position().x + cell.size().width / 2, 0) / cells.length;
  cells.forEach(cell => {
    const { y } = cell.position();
    const { width } = cell.size();
    cell.position(centerX - width / 2, y);
  });
}

export function alignRight(cells: JointElement[]): void {
  const maxRight = Math.max(...cells.map(cell => cell.position().x + cell.size().width));
  cells.forEach(cell => {
    const { y } = cell.position();
    const { width } = cell.size();
    cell.position(maxRight - width, y);
  });
}

export function alignTop(cells: JointElement[]): void {
  const minY = Math.min(...cells.map(cell => cell.position().y));
  cells.forEach(cell => {
    const { x } = cell.position();
    cell.position(x, minY);
  });
}

export function alignMiddle(cells: JointElement[]): void {
  const centerY = cells.reduce((sum, cell) => sum + cell.position().y + cell.size().height / 2, 0) / cells.length;
  cells.forEach(cell => {
    const { x } = cell.position();
    const { height } = cell.size();
    cell.position(x, centerY - height / 2);
  });
}

export function alignBottom(cells: JointElement[]): void {
  const maxBottom = Math.max(...cells.map(cell => cell.position().y + cell.size().height));
  cells.forEach(cell => {
    const { x } = cell.position();
    const { height } = cell.size();
    cell.position(x, maxBottom - height);
  });
}

export function distributeHorizontally(cells: JointElement[]): void {
    const sorted = [...cells].sort((a, b) => a.position().x - b.position().x);
    const first = sorted[0];
    const last = sorted[sorted.length - 1];

    const firstX = first.position().x;
    const lastX = last.position().x;
    const totalWidth = sorted.reduce((sum, cell) => sum + cell.size().width, 0);
    const availableSpace = (lastX + last.size().width) - firstX - totalWidth;
    const gap = sorted.length > 1 ? availableSpace / (sorted.length - 1) : 0;

    let currentX = firstX;
    sorted.forEach(cell => {
      const { y } = cell.position();
      cell.position(currentX, y);
      currentX += cell.size().width + gap;
    });
  }

  export function distributeVertically(cells: JointElement[]): void {
    const sorted = [...cells].sort((a, b) => a.position().y - b.position().y);
    const first = sorted[0];
    const last = sorted[sorted.length - 1];

    const firstY = first.position().y;
    const lastY = last.position().y;
    const totalHeight = sorted.reduce((sum, cell) => sum + cell.size().height, 0);
    const availableSpace = (lastY + last.size().height) - firstY - totalHeight;
    const gap = sorted.length > 1 ? availableSpace / (sorted.length - 1) : 0;

    let currentY = firstY;
    sorted.forEach(cell => {
      const { x } = cell.position();
      cell.position(x, currentY);
      currentY += cell.size().height + gap;
    });
  }


export const cellFormat = (function () {
  let copiedStyle: any = null;
  function copy(cell: dia.Cell) {
    if (!cell) return;

    copiedStyle = {
      fill: cell.attr('body/fill'),
      stroke: cell.attr('body/stroke'),
      strokeWidth: cell.attr('body/strokeWidth'),
      fillOpacity: cell.attr('body/fillOpacity'),
      strokeOpacity: cell.attr('body/strokeOpacity'),
      strokeDasharray: cell.attr('body/strokeDasharray'),
      textContainer: cell.attr('textContainer/style')
    };
  }

  function paste(cells: JointElement[]) {
    if (!copiedStyle || !Array.isArray(cells)) return;
    cells.forEach(cell => {
      cell.attr('body/fill', copiedStyle.fill)
      cell.attr('body/stroke', copiedStyle.stroke)
      cell.attr('body/strokeWidth', copiedStyle.strokeWidth)
      cell.attr('body/fillOpacity', copiedStyle.fillOpacity)
      cell.attr('body/strokeOpacity', copiedStyle.strokeOpacity)
      cell.attr('body/strokeDasharray', copiedStyle.strokeDasharray)
      cell.attr('textContainer/style', copiedStyle.textContainer)
    });
  }

  function isCopied() {
    return copiedStyle !== null;
  }
  return {
    copy,
    paste,
    isCopied
  }
})();
